<template>
    <div class="modal fade" tabindex="-1" aria-labelledby="accountModalLabel" :id="id">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ menu.id ? 'メニュー編集' : '新規メニュー作成' }}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <ul class="nav nav-tabs nav-tabs-underline mb-3">
                        <li class="nav-item">
                            <a href="#" class="nav-link" :class="{active: menu.is_caption}" @click.prevent="menu.is_caption = 1">見出し</a>
                        </li>
                        <li class="nav-item">
                            <a href="#" class="nav-link" :class="{active: !menu.is_caption}" @click.prevent="menu.is_caption = 0">メニュー</a>
                        </li>
                    </ul>
                    <div class="mb-3">
                        <label class="form-label fw-semibold">
                            <i class="fa-solid fa-bars"></i>
                            <span v-if="menu.is_caption">見出し名</span>
                            <span v-else>メニュー名</span>
                        </label>
                        <input type="text" class="form-control" v-model="menu.name" required>
                    </div>
                    <div class="mb-3" v-if="!menu.is_caption">
                        <label class="form-label fw-semibold">
                            <i class="fa-solid fa-folder-tree"></i>
                            パス
                        </label>
                        <input type="text" class="form-control" v-model="menu.path" 
                            placeholder="空欄にすると見出しになります"
                            :disabled="menu.is_caption">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="close">キャンセル</button>
                    <button type="button" class="btn btn-primary" @click="save">保存</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            default: 'menu-editor'
        },
        menu_id: {
            default: null,
        },
    },
    data() {
        return {
            menu: {},
            org_path: null,
        };
    },
    methods: {
        reload() {
            if (!this.menu_id) {
                this.menu = {
                    is_caption: 1,
                };
                return;
            }
            axios.get("/api/admin/menu?id=" + this.menu_id).then(res => {
                if (!res.data.path) {
                    res.data.is_caption = 1;
                } else {
                    res.data.is_caption = 0;
                }
                this.menu = res.data;
            }).catch(err => {Alert.err(err)});
        },
        close() {
            this.$emit('close', this.id);
        },
        changeCaption() {
            if (this.menu.is_caption) {
                this.org_path = this.menu.path;
                this.menu.path = null;
            } else {
                this.menu.path = this.org_path;
            }
        },
        save() {
            axios.post('/api/admin/menu', this.menu).then(() => {
                this.$emit('saved', this.id);
                this.close();
                Alert.msg("メニューを保存しました。");
            }).catch(err => {Alert.err(err)});
        }
    },
    mounted() {
        $(`#${this.id}`).on("show.bs.modal", (e) => {
            this.reload();
        });
    },
}
</script>
